import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteItemGroupApi } from "../../apiservice/inventory";
import { getItemGroupsApi } from "../../apiservice/accounts";
import { saveGroupManageApi } from "../../apiservice/hrpayroll";

// Fetch Groups
export const fetchGroupsList = createAsyncThunk(
  "groups/fetchGroupsList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemGroupsApi({ type: "all" });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create or Update Group
export const createOrUpdateGroup = createAsyncThunk(
  "groups/createOrUpdateGroup",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveGroupManageApi(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Delete Group
export const deleteGroup = createAsyncThunk(
  "groups/deleteGroup",
  async (group_id, { rejectWithValue }) => {
    try {
      const res = await deleteItemGroupApi({ group_id });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
